import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from 'src/app/shared/utils/auth.guard';

import { OrderComponent } from './order.component';


const routes: Routes = [
  {
    path: 'order/:entityId',
    component: OrderComponent,
    data: { breadcrumb: 'My Order' }
  }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class OrderRoutingModule { }
